// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","195":"68a95b6c8b31784b6412","243":"307c1cf31df043fbcfea","498":"f579834589d1bdf2a948","556":"11953fbcf2f8f46083bc","595":"f7776ac79a7da92f941a"}[chunkId] + ".bundle.js";
};